import { useTranslation } from 'react-i18next';
import { Card } from '@/common/components/Card/Card';
import { Grid } from '@/common/components/Grid/Grid';
import { Heading } from '@/common/components/Heading/Heading';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { Stack } from '@/common/components/Stack/Stack';
import { getCountryByCode } from '@/common/constants/country-list';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { TaxUtils } from '@/common/utils/tax';

export function CompanyDetailsPage() {
  const { t } = useTranslation();

  const { company } = useEmployeeDetails();

  const companyLegalAddress = company.addresses.find(
    (address) => address.type === 'legal'
  );

  return (
    <PageLayout
      headerProps={{
        title: t('dashboard.company_info.title'),
        backButton: true,
      }}
    >
      <Card plain>
        <Stack gap="lg">
          <Heading level={4}>
            {t('dashboard.company_info.labels.legal_info')}
          </Heading>
          <Grid columnBasis="basis-[13.4rem]" gap="lg" maxColumns={2}>
            <LabeledValue
              label={t('dashboard.company_info.labels.legal_name')}
              value={company.name}
              copyable
            />
            <LabeledValue
              label={t('dashboard.company_info.labels.tax_id')}
              value={TaxUtils.formatTaxId(company.taxId)}
              copyable
            />
          </Grid>
        </Stack>
      </Card>
      <Card plain>
        <Stack gap="lg">
          <Heading level={4}>
            {t('dashboard.company_info.labels.address')}
          </Heading>
          {companyLegalAddress && (
            <LabeledValue
              label={t('dashboard.company_info.labels.street')}
              value={[
                companyLegalAddress?.addressLine1 ?? '',
                companyLegalAddress?.addressLine2,
              ].join(' ')}
              copyable
            />
          )}
          <Grid columnBasis="basis-[13.4rem]" gap="lg" maxColumns={3}>
            <LabeledValue
              label={t('dashboard.company_info.labels.zipcode')}
              value={companyLegalAddress?.zipCode}
              copyable
            />
            <LabeledValue
              label={t('dashboard.company_info.labels.city')}
              value={companyLegalAddress?.city}
              copyable
            />
            <LabeledValue
              label={t('dashboard.company_info.labels.country')}
              value={
                getCountryByCode(companyLegalAddress?.country ?? '')?.name ??
                companyLegalAddress?.country
              }
              copyable
            />
          </Grid>
        </Stack>
      </Card>
    </PageLayout>
  );
}
